import Joi from 'joi';

const YearlyValueSchema = Joi.object({
  Value: Joi.number().min(0).required()
}).unknown();

const SurveyAnswerSchema = Joi.object({
  SurveyResultValues: Joi.array().items(YearlyValueSchema)
}).unknown();

const SurveyQuestionSchema = Joi.object({
  SurveyResults: Joi.array().items(SurveyAnswerSchema)
}).unknown();

const SurveyResultsPageValidator = {
  editSchema: Joi.object({
    questions: Joi.array().items(SurveyQuestionSchema)
  }).unknown()
};

export default SurveyResultsPageValidator;
